import {
  Lager_Auth_Group,
  Lager_Auth_User_Groups,
  Lager_Invitations,
  Lager_Treyd_Users,
  Orders_Companies,
} from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type BaseOrderCompanyType = Pick<
  Orders_Companies,
  | 'id'
  | 'name'
  | 'org_no'
  | 'country'
  | 'address'
  | 'zip_code'
  | 'town'
  | 'county'
  | 'phone_no'
  | 'limit'
  | 'limit_currency'
  | 'is_active'
>;
type auth_group = { auth_group: Pick<Lager_Auth_Group, 'name'> };
type user_groups = {
  user_groups: Array<
    Pick<Lager_Auth_User_Groups, 'id'> & { auth_group: auth_group }
  >;
};
type BaseUsers = Pick<
  Lager_Treyd_Users,
  | 'id'
  | 'name'
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'identity_reference'
  | 'identity_type'
  | 'identity_verified'
  | 'country'
  | 'confirmed_at'
  | 'invitation_sent_at'
  | 'confirmation_sent_at'
  | 'profile_id'
  | 'email_confirmed'
  | 'financier_id'
  | 'company_id'
  | 'date_joined'
  | 'phone_no'
  | 'phone_code'
  | 'user_groups'
  | 'invitation_accepted_at'
  | 'user_id'
> & { user_groups: user_groups };

export const BASE_USERS = gql`
  fragment BaseUsers on lager_treyd_users {
    id
    name
    first_name
    last_name
    email
    identity_reference
    identity_type
    country
    identity_verified
    confirmed_at
    invitation_sent_at
    confirmation_sent_at
    profile_id
    email_confirmed
    financier_id
    company_id
    date_joined
    phone_no
    phone_code
    user_id
    user_groups {
      id
      auth_group {
        name
      }
    }
  }
` as TypedDocumentNode<BaseUsers>;

export type User = Pick<
  Lager_Treyd_Users,
  'can_sign_alone' | 'member_id' | 'is_ubo'
> & {
  invitations: Array<
    Pick<
      Lager_Invitations,
      | 'accepted_at'
      | 'invited_by_id'
      | 'invited_user_id'
      | 'created_at'
      | 'is_accepted'
    >
  >;
} & BaseUsers & { last_login: string };

export const USERS = gql`
  ${BASE_USERS}
  fragment Users on orders_companies {
    company_users(where: { is_active: { _eq: true } }) {
      ...BaseUsers
      can_sign_alone
      member_id
      invitation_accepted_at
      last_login
      is_ubo
    }
  }
` as TypedDocumentNode<User[]>;

export type CompanyUsers = BaseOrderCompanyType & User[];
export const CompanyUsersFragment = gql`
  ${USERS}
  fragment CompanyUsers on orders_companies {
    ...Users
  }
` as TypedDocumentNode<CompanyUsers>;

export type GetCompanyUsersType = {
  orders_companies_by_pk: {
    company_users: CompanyUsers;
  };
};
type GetCompanyUsersQueryVariables = { company_id: number };

export const getCompanyUsersById = gql`
  ${CompanyUsersFragment}
  query getCompanyUsers($company_id: bigint!) {
    orders_companies_by_pk(id: $company_id) {
      id
      ...CompanyUsers
    }
  }
` as TypedDocumentNode<GetCompanyUsersType, GetCompanyUsersQueryVariables>;
